import { render, staticRenderFns } from "./MajorShareholdersHk.vue?vue&type=template&id=58b427ea&scoped=true"
import script from "./MajorShareholdersHk.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersHk.vue?vue&type=script&lang=js"
import style0 from "./MajorShareholdersHk.vue?vue&type=style&index=0&id=58b427ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b427ea",
  null
  
)

export default component.exports